import React from "react";
import { Link } from "react-router-dom";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("id-ID", { dateStyle: "medium" }).format(date);
}

export default function BlogCard({ blog }) {
  return (
    <article className="group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
      <Link to={`/blog/${blog?.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-gray-100">
          {blog?.featured_image ? (
            <img
              src={blog.featured_image}
              alt={blog?.cover_alt || blog?.title}
              className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-sm text-gray-400">
              Tidak ada gambar
            </div>
          )}
        </div>
      </Link>

      <div className="p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-full bg-orange-50 px-2.5 py-1 font-medium text-orange-700">
            {blog?.category_name || "Artikel"}
          </span>
          <span className="text-gray-400">•</span>
          <span className="text-gray-500">{formatDate(blog?.published_at)}</span>
        </div>

        <Link to={`/blog/${blog?.slug}`}>
          <h3 className="line-clamp-2 text-xl font-semibold text-gray-900 transition group-hover:text-orange-600">
            {blog?.title}
          </h3>
        </Link>

        <p className="mt-3 line-clamp-3 text-sm leading-7 text-gray-600">
          {blog?.excerpt || "Belum ada ringkasan artikel."}
        </p>

        <div className="mt-4 flex items-center justify-between text-sm text-gray-500">
          <span>{blog?.author_name || "Admin"}</span>
          <span>{blog?.reading_time || "Baca selengkapnya"}</span>
        </div>
      </div>
    </article>
  );
}
